import React from 'react'
import styled from 'styled-components'

import { AlertVariant } from 'components/styled/alert/context'
import { AlertIcon } from 'components/styled/icon/alert/alert-icon'
import { Modal } from './index'
import { ModalProps } from './modal-component'
import { Icon } from '../icon'

export interface NotificationProps extends ModalProps {
  icon?: string
  alertIcon?: AlertVariant
  flippedView?: boolean
  children?: React.ReactNode
}

const StyledNotification = styled.div`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.mediaQuery.phone} {
    flex-direction: column;
    align-items: flex-start;
    row-gap: ${({ theme }) => theme.space.s32};
    padding-left: ${({ theme }) => theme.space.s20};
  }
`

const IconWrapper = styled.div<{ $flippedView?: boolean }>`
  padding: ${({ theme }) => theme.space.s4};
  margin: ${({ theme, $flippedView }) =>
    $flippedView ? `0 0 0 ${theme.space.s24}` : `0 ${theme.space.s24} 0 0`};

  background-color: ${({ theme }) => theme.color.grey07};
  border-radius: ${({ theme }) => theme.space.s20};

  align-self: flex-start;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
`

export const Notification: React.FC<NotificationProps> = ({
  icon,
  alertIcon,
  children,
  hasOverlay = false,
  flippedView = false,
  size = 'small',
  ...props
}) => (
  <Modal hasOverlay={hasOverlay} size={size} {...props}>
    <StyledNotification>
      {icon && (
        <IconWrapper $flippedView={flippedView}>
          <Icon type={icon} size="s32" />
        </IconWrapper>
      )}
      {alertIcon && <AlertIcon flippedView={flippedView} variant={alertIcon} />}
      <div>{children}</div>
    </StyledNotification>
  </Modal>
)
